module.exports = __webpack_public_path__ + "static/media/NewDesignHrwarning.0cda78c9.svg";